"use client";

import { singInUser } from "@/app/actions/signInUser";
import { Button } from "@/components/ui/button";
import { LoaderCircle } from "lucide-react";
import { type ClientSafeProvider } from "node_modules/next-auth/lib/client";
import { type MouseEventHandler, useCallback, useTransition } from "react";

export function LoginButton({
  provider,
  onSigningInUser,
  onSigningInUserFailed,
}: {
  readonly onSigningInUser?: () => void;
  readonly onSigningInUserFailed?: () => void;
  readonly provider: ClientSafeProvider;
}) {
  const [singingInUser, startUserSignInProcess] = useTransition();

  const handleOnLogin = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (e) => {
      startUserSignInProcess(async () => {
        try {
          e.stopPropagation();
          e.preventDefault();
          onSigningInUser?.();
          await singInUser(provider.id);
        } catch (ex) {
          console.log(ex);
          onSigningInUserFailed?.();
        }
      });
    },
    [onSigningInUser, onSigningInUserFailed, provider.id],
  );

  return (
    <Button
      className="w-full"
      tabIndex={2}
      variant="outline"
      onClick={handleOnLogin}
      disabled={singingInUser}
    >
      {singingInUser ? (
        <LoaderCircle className="animate-spin" />
      ) : (
        provider.name
      )}
    </Button>
  );
}
